'use strict';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {stopPropagation} from '../../../core-utilities/react-utils';
import {ChatListContainer} from '../ChatList/ChatListContainer';
import {ChatSubscriberPanel} from '../ChatSubscriberPanel';
import {ChatListSettings} from '../ChatListSettings';

export const modalOptions = {
  isLegacy: true,
  modalProps: {
    modalClass: 'ChatChannelModal',
    useScrollWrapper: false,
    animation: 'slide-in-right',
  },
};

export class ChatChannelModalComponent extends Component {
  static propTypes = {
    onSuccess: T.func/* .isRequired*/,
    onCancel: T.func/* .isRequired*/,
  };

  constructor(props) {
    super(props);
    this.state = {
      init: !!props.parentId,
      showSubscribers: false,
      showSettings: false,
    };
    this.handleShowSubscribers = this.handleShowSubscribers.bind(this);
    this.handleHideSubscribers = this.handleHideSubscribers.bind(this);
    this.handleShowSettings = this.handleShowSettings.bind(this);
    this.handleHideSettings = this.handleHideSettings.bind(this);
  }

  handleShowSubscribers(e) {
    if (!this.state.showSubscribers) {
      this.setState({showSubscribers: true});
    }
  }

  handleHideSubscribers(e) {
    if (this.state.showSubscribers) {
      this.setState({showSubscribers: false});
    }
  }

  handleShowSettings(e) {
    if (!this.state.showSettings) {
      this.setState({showSettings: true});
    }
  }

  handleHideSettings(e) {
    if (this.state.showSettings) {
      this.setState({showSettings: false});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props$) {
      setTimeout(() => {
        this.props$.next(nextProps);
      });
    }
  }

  componentDidMount() {
    if (!this.state.init) {
      this.props$ = new ReplaySubject(1);
      this.props$.next(this.props);

      this.props$
        .map(props => props.parentId)
        .filter(parentId => !!parentId)
        .take(1)
        .subscribe(() => this.setState({init: true}));
    }
  }

  componentWillUnmount() {
    this.stateSubscription && this.stateSubscription.unsubscribe();
  }

  render() {
    const state = this.state;
    const props = this.props;
    // TODO: handle case of init:false, show error
    // TODO: configure to use the subheader with additional options like starting a video call
    return (
      <div
        className={classNames("right-slide-modal", props.className)}
        onClick={stopPropagation}
      >
        <ChatListContainer
          className={classNames({
            'hide-elem': state.showSettings || state.showSubscribers,
          })}
          parentId={props.parentId}
          channel={props.channel}
          allowNav={props.allowNav}
          allowVideoChat={props.allowVideoChat}
          permissionsMode={props.permissionsMode}
          showSubHeader={true}
          init={state.init}
          onClose={props.onSuccess}
          onShowSubscribers={this.handleShowSubscribers}
          onShowSettings={this.handleShowSettings}
        />
        {!state.showSettings ? null : (
          <ChatListSettings
            parentId={props.parentId}
            channel={props.channel}
            onClose={this.handleHideSettings}
            onHidePanel={this.handleHideSettings}
          />
        )}
        {!state.showSubscribers ? null : (
          <ChatSubscriberPanel
            parentId={props.parentId}
            onHidePanel={this.handleHideSubscribers}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatChannelModal/ChatChannelModalComponent.js